import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Sparkles, LogOut, LayoutDashboard, Compass, MessageCircle } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function NavBar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const nav = useNavigate();

  const links = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
    { to: "/scanner", label: "Scanner", icon: Compass, testid: "nav-scanner" },
    { to: "/chat", label: "Community", icon: MessageCircle, testid: "nav-chat" },
  ];

  return (
    <nav className="relative z-20 max-w-6xl mx-auto px-4 sm:px-8 pt-4 sm:pt-6 flex items-center justify-between gap-2">
      <Link to="/dashboard" className="flex items-center gap-2 shrink-0" data-testid="nav-brand">
        <div className="w-9 h-9 rounded-full glass-gold flex items-center justify-center">
          <Sparkles size={18} className="text-[#C8A96E]" />
        </div>
        <span className="font-heading text-xl sm:text-2xl tracking-tight">StarGrid</span>
      </Link>

      <div className="flex items-center gap-0 sm:gap-1 min-w-0">
        {links.map((l) => {
          const active = location.pathname.startsWith(l.to);
          const Icon = l.icon;
          return (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={`px-2.5 sm:px-4 py-2 text-xs uppercase tracking-[0.2em] flex items-center gap-2 transition-colors ${
                active ? "text-[#C8A96E]" : "text-[#A89C98] hover:text-white"
              }`}
            >
              <Icon size={14} />
              <span className="hidden sm:inline">{l.label}</span>
            </Link>
          );
        })}
        <div className="w-px h-6 bg-white/10 mx-1 sm:mx-2" />
        {user && (
          <div className="flex items-center gap-2">
            <img src={user.picture || "https://via.placeholder.com/40"} alt="" className="w-8 h-8 rounded-full border border-white/20" />
            <span className={`hidden sm:inline text-sm ${user.vip_lifetime ? "vip-name" : "text-white"}`} data-testid="nav-username">{user.name?.split(" ")[0] || "You"}</span>
            <button data-testid="nav-logout" onClick={async () => { await logout(); nav("/", { replace: true }); }} className="ml-1 sm:ml-2 p-1.5 text-[#A89C98] hover:text-white">
              <LogOut size={16} />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
